'use client';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["SHOW"] = "SHOW";
    ACTIONS["HIDE"] = "HIDE";
    ACTIONS["TOGGLE"] = "TOGGLE";
    ACTIONS["SET_KEYWORD"] = "SET_KEYWORD";
    ACTIONS["APPLY_CALLBACK"] = "APPLY_CALLBACK";
    ACTIONS["SYNC_TEMPORARY_TO_VALUE"] = "SYNC_TEMPORARY_TO_VALUE";
    ACTIONS["SET_SELECT_PARENT_ID"] = "SET_SELECT_PARENT_ID";
    ACTIONS["MOBILE_SET_SELECT_PARENT_ID"] = "MOBILE_SET_SELECT_PARENT_ID";
    ACTIONS["REMOVE_SELECTED_OR_HOVER"] = "REMOVE_SELECTED_OR_HOVER";
    ACTIONS["SET_HOVER"] = "SET_HOVER";
    ACTIONS["SET_HOVER_ID"] = "SET_HOVER_ID";
    ACTIONS["SET_MOUSE_LEAVE"] = "SET_MOUSE_LEAVE";
    ACTIONS["SET_TEMPORARY_VALUE"] = "SET_TEMPORARY_VALUE";
    ACTIONS["SET_SINGLE_TEMPORARY_VALUE"] = "SET_SINGLE_TEMPORARY_VALUE";
    ACTIONS["REMOVE_ALL_TEMPORARY_VALUE"] = "REMOVE_ALL_TEMPORARY_VALUE";
    ACTIONS["REMOVE_PARENT_ID"] = "REMOVE_PARENT_ID";
    ACTIONS["SET_VALUE_FROM_PROP"] = "SET_VALUE_FROM_PROP";
    ACTIONS["ON_CANCEL"] = "ON_CANCEL";
    ACTIONS["ON_CONFIRM"] = "ON_CONFIRM";
    ACTIONS["ON_DROPDOWN_ITEM_FOCUS"] = "ON_DROPDOWN_ITEM_FOCUS";
    ACTIONS["SET_SEARCH_RESULT"] = "SET_SEARCH_RESULT";
})(ACTIONS || (ACTIONS = {}));

export { ACTIONS };
//# sourceMappingURL=actions.js.map
